import { CUSTOM_RPC_BY_CHAIN } from '@package/smart-wallet/constants';
import { ethers } from 'ethers';
import { bsc } from 'viem/chains';

export const getProvider = (chainId = bsc.id) => {
  return new ethers.JsonRpcProvider(
    CUSTOM_RPC_BY_CHAIN[chainId] ?? 'https://bsc-rpc.publicnode.com',
  );
};

export const isSignerInitialized = (smartAccountAddress: string) => {
  if (smartAccountAddress === '') {
    throw new Error(
      'Error sending transaction: Signer or safe address not initialized',
    );
  }
};
